import { PricingConditionModel } from '../../shared/types/pricingCondition'

/*
 * Platnost cennika podla validFrom / validTo (aktualny cas):
 *  - active   = plati teraz
 *  - expired  = platnost skoncila (sem patria aj "zmazane" cenniky - zmazanie nastavi validTo na aktualny cas)
 *  - upcoming = zacne platit az v buducnosti
 */
export type PricingConditionValidity = 'active' | 'expired' | 'upcoming'

export const PRICING_CONDITION_VALIDITIES: PricingConditionValidity[] = ['active', 'expired', 'upcoming']

export const getPricingConditionValidity = (
    condition: PricingConditionModel,
    now: Date = new Date()
): PricingConditionValidity => {
    const from = condition.validFrom ? new Date(condition.validFrom) : null
    const to = condition.validTo ? new Date(condition.validTo) : null
    if (to && !isNaN(to.getTime()) && to.getTime() < now.getTime()) return 'expired'
    if (from && !isNaN(from.getTime()) && from.getTime() > now.getTime()) return 'upcoming'
    return 'active'
}
